import { SvgIcon, SvgIconProps } from "@mui/material";

const FlightHotelIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      {/* Flight */}
      <path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9L2 14v2l8-2.5V19l-2 1.5V22l3-1 3 1v-1.5L13 19v-5.5l8 2.5z"/>

      {/* Hotel */}
      <rect x="2" y="15" width="6" height="7" rx="1"/>
      <rect x="3" y="16" width="1" height="1"/>
      <rect x="5" y="16" width="1" height="1"/>
      <rect x="3" y="18" width="1" height="1"/>
      <rect x="5" y="18" width="1" height="1"/>
    </SvgIcon>
  );
};

export default FlightHotelIcon;
